import { useState } from "react";
import { Timer, Pause } from "lucide-react";
import { cn } from "@/lib/utils";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useWorkTimerContext } from "./WorkTimerProvider";
import { WorkTimer } from "./WorkTimer";

function formatTime(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
}

export function TimerFloatingWidget() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { timerState } = useWorkTimerContext();

  if (!timerState.isRunning) return null;

  const phaseColor = timerState.phase === "focus"
    ? "bg-sage text-white"
    : "bg-honey text-foreground";

  return (
    <>
      <button
        onClick={() => setDialogOpen(true)}
        className={cn(
          "fixed bottom-20 right-4 z-40 flex items-center gap-2 px-4 py-2.5 rounded-full shadow-lg",
          "animate-in fade-in slide-in-from-right-4 duration-500 delay-300",
          "transition-all hover:scale-105 active:scale-95",
          "backdrop-blur-sm border border-border/30",
          phaseColor,
        )}
        aria-label="Open focus timer"
      >
        {timerState.isPaused ? (
          <Pause className="h-4 w-4" />
        ) : (
          <Timer className="h-4 w-4 animate-pulse" />
        )}
        <span className="font-mono text-sm font-semibold tabular-nums">
          {formatTime(timerState.timeRemaining)}
        </span>
      </button>

      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent className="sm:max-w-md max-h-[85vh] overflow-y-auto">
          <DialogTitle className="sr-only">Focus Session Timer</DialogTitle>
          <WorkTimer onClose={() => setDialogOpen(false)} />
        </DialogContent>
      </Dialog>
    </>
  );
}